import {
  interaction10,
  interaction5,
  neutral0,
  neutral5,
  pxToRem,
  spacing1,
  spacing2,
  spacing3,
  spacing6,
} from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const QuickOrderTableWrapper = styled.div`
  position: relative;
  margin-top: ${spacing6};
`;

export const QuickOrderItemCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing2};
  height: ${pxToRem(96)};
  min-width: 0;
`;

export const QuickOrderItemImage = styled.img`
  flex-shrink: 0;
  width: ${pxToRem(48)};
  height: ${pxToRem(48)};
  object-fit: contain;
`;

export const QuickOrderItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(2)};
  min-width: 0;
  overflow: hidden;
`;

export const QuickOrderItemMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${spacing1};
  row-gap: 0;
  min-width: 0;
`;

export const QuickOrderQuantityCellWrapper = styled.div`
  position: relative;
  width: 100%;

  [data-testid='number-field--component--div'] {
    width: 100%;
  }

  input {
    text-align: center;
  }
`;

export const QuickOrderAllQuantityCellWrapper = styled(
  QuickOrderQuantityCellWrapper
)`
  border-radius: 4px;
  background-color: ${interaction5.hex};
  padding: ${spacing2};

  &:focus-within {
    background-color: ${interaction10.hex};
  }
`;

export const QuickOrderRecheckWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing1};
`;

export const QuickOrderFooterActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing3};
  width: 100%;
`;

export const QuickOrderFooterTotals = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing3};
  margin-left: auto;
  padding: ${spacing1} ${spacing2};
  background-color: ${neutral5.hex};
  border-radius: 8px;
  width: ${pxToRem(290)};
`;

export const QuickOrderFooterTotal = styled.div`
  width: ${pxToRem(115)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QuickOrderTableHeaderActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing3};
  width: 100%;

  > button {
    margin-left: auto;
  }
`;

export const QuickOrderMastheadDescription = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing3};

  img {
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    object-fit: contain;
    background-color: ${neutral0.hex};
  }
`;
